import { STORAGE_ACCOUNT } from '../../../Constants';
import axios from "../../../Axios";
import { toast } from "react-toastify";
import axios2 from "axios";
import { Urls } from "../../../Urls";
import { getCompanyFolderName, getUserFolderName } from "../../../Utility";
import { validateAndReadFile } from "../../CompanyProfileNew/FreightMaster/Utility/utility";
import { reserveAzureSignedUrl } from "../../../hooks/useAzureFileUpload";
import { useContext } from 'react';
import { UserApiContext } from '../../UserDetailsContext/UserDetailsContext';

const FileUploader = ({
  onChange,
  fileid,
  toggleLoader = () => null,
  supportedFiles = [],
  UnsupportedError,
  uploadedfor,
  uploadTo = "private",
}) => {
  const { userDetails, companyProfile } = useContext(UserApiContext)
  const getWriteableUrl = async (file) => {
    let fileName = `${uploadedfor}_${file.name}`.replace(/\s+/g, "_");
    let body = {};

    if (uploadedfor === "PPTGENERATION") {
      body = {
        action: "upload",
        containerName: "ppt-collections",
        accountName: "lnclientdata",
        fileName: `${getCompanyFolderName(userDetails.email)}/${getUserFolderName(userDetails.email, companyProfile?.domain_data?.company_id)}/raw/${fileName}`,
      };
      return axios.post(Urls.fileService, body).then((res) => res.data);
    }

    if (uploadTo === "private") {
      return await reserveAzureSignedUrl(fileName);
    }

    body = {
      action: "upload",
      containerName: "public-container",
      accountName: STORAGE_ACCOUNT,
      fileName,
    };

    return axios.post(Urls.fileService, body).then((res) => res.data);
  };

  const uploadFiletoBlob = (file, url, fileid) => {
    axios2
      .put(url, file, {
        headers: {
          "x-ms-blob-type": "blockblob",
          "x-ms-blob-content-disposition": file.name,
          "Content-Disposition": file.name,
        },
      })
      .then((res) => {
        onChange(fileid, file.name, url);
      })
      .catch((err) => {
        toast.error("Failed to Upload");
      });
  };

  const validateFile = (file) => {
    if (file && file.size && file.size < 20 * 1024 * 1024) {
      return true;
    } else {
      toast.warn(`Please upload file below 20 MB`);
      return false;
    }
  };

  const onFileSelected = async (e) => {
    if (e.target.files.length > 0) {
      const result = await validateAndReadFile(e.target.files[0], ["image"]);

      if (result.error) {
        toast.error(result.error);
        return false;
      }
      let file = e.target.files[0];
      let ext = file.name.substr(file.name.lastIndexOf(".") + 1).toLowerCase();
      if (supportedFiles.includes(ext)) {
        if (validateFile(file)) {
          toggleLoader(true);
          getWriteableUrl(file).then((res) => {
            if (res !== "Error") {
              uploadFiletoBlob(file, res.url, res.file_name);
            }
          });
        }
      } else {
        toast.warn(UnsupportedError);
      }
    } else {
      toast.warn("Please Select File to Upload");
    }
  };

  return (
    <input
      type="file"
      id={fileid}
      onChange={(e) => onFileSelected(e)}
      style={{ display: "none" }}
    ></input>
  );
};

export default FileUploader;
